import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import { consumeTheme } from '../../utils/theme';
import { emptyFn } from '../../utils/helper';
import ua from '@tencent/docs-user-agent';
import Loading from '../Loading';
import { decideKeepDom } from '../../utils/keepDom';
import { i18n } from '../../common/locale';
import Surroundings from './Surroundings';
import TouchGesture from './TouchGesture';
import { getActionSheetConfig } from './utils';
export var PREVIEW_TRANSITION_DURATION = 300;
var Preview = (function (_super) {
    __extends(Preview, _super);
    function Preview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.maskRef = React.createRef();
        _this.safeAreaRef = React.createRef();
        _this.wrapperRef = React.createRef();
        _this.pageRef = React.createRef();
        _this.imageWrapperRef = React.createRef();
        _this.imageRef = React.createRef();
        _this.touchGesture = null;
        _this.state = {
            currentIndex: _this.props.initialIndex,
            imageStates: {},
            screenWidth: window.innerWidth,
            isWidgetsVisible: true,
            isActionSheetVisible: false,
            isSlideOutClose: false,
        };
        _this.setImageState = function (imageUrl, newState) {
            var imageStates = _this.state.imageStates;
            imageStates[imageUrl] = imageUrl ? newState : 'error';
            _this.setState({ imageStates: imageStates });
        };
        _this.handleLongTap = function () {
            var _a, _b;
            var _c = _this.props, onLongTapImage = _c.onLongTapImage, visible = _c.visible, actionSheetConfig = _c.actionSheetConfig;
            var imageList = _this.imageList;
            onLongTapImage(_this.state.currentIndex);
            (_b = (_a = window.navigator).vibrate) === null || _b === void 0 ? void 0 : _b.call(_a, 50);
            var effectiveActionSheetConfig = getActionSheetConfig(imageList, actionSheetConfig);
            if (visible && (effectiveActionSheetConfig === null || effectiveActionSheetConfig === void 0 ? void 0 : effectiveActionSheetConfig.length)) {
                _this.setState({ isActionSheetVisible: true });
            }
        };
        _this.handleLongTapCancel = function () {
            _this.setState({ isActionSheetVisible: false });
        };
        _this.handleTap = function () {
            _this.props.onTapImage(_this.state.currentIndex);
        };
        _this.canPinchZoom = function () {
            var _a = _this.state, imageStates = _a.imageStates, currentIndex = _a.currentIndex;
            return imageStates[_this.getUrl(currentIndex)] === 'loaded';
        };
        _this.handleResize = function () {
            if (!_this.props.visible) {
                return;
            }
            _this.setState({
                screenWidth: window.innerWidth
            }, function () {
                var _a, _b;
                (_a = _this.touchGesture) === null || _a === void 0 ? void 0 : _a.toCurrentPageLeft(0);
                (_b = _this.touchGesture) === null || _b === void 0 ? void 0 : _b.scaleOnce();
            });
        };
        _this.handlePageChange = function (index) {
            if (index === _this.state.currentIndex) {
                return;
            }
            _this.setState({
                currentIndex: index
            });
            _this.props.onChange(index);
        };
        _this.requestClose = function (isSlideOutClose) {
            if (isSlideOutClose === void 0) { isSlideOutClose = false; }
            if (_this.state.isActionSheetVisible) {
                return;
            }
            _this.setState({ isSlideOutClose: isSlideOutClose });
            _this.props.onClose();
        };
        _this.handleWidgetsVisibilityChange = function (isWidgetsVisible) {
            if (_this.props.visible && _this.state.isWidgetsVisible !== isWidgetsVisible) {
                _this.setState({ isWidgetsVisible: isWidgetsVisible });
            }
        };
        _this.handleClick = function () {
            if (_this.props.allowTapToClose && ua.isIPad) {
                _this.requestClose();
            }
        };
        _this.handleActionSheetClose = function () {
            _this.setState({ isActionSheetVisible: false });
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, visible = _a.visible, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, maskStyle = _a.maskStyle, showPageNumber = _a.showPageNumber, renderWidgets = _a.renderWidgets, containerDom = _a.containerDom, zIndex = _a.zIndex, testId = _a.testId, actionSheetConfig = _a.actionSheetConfig, showCloseButton = _a.showCloseButton;
            var _b = _this.state, currentIndex = _b.currentIndex, isWidgetsVisible = _b.isWidgetsVisible, isActionSheetVisible = _b.isActionSheetVisible, isSlideOutClose = _b.isSlideOutClose;
            if (!decideKeepDom.call(_this, PREVIEW_TRANSITION_DURATION, visible)) {
                return null;
            }
            var classes = classNames(prefixCls, className, prefixCls + "-" + (visible ? 'visible' : 'hidden'), isSlideOutClose ? prefixCls + "-slide-out" : '');
            var maskClass = classNames(prefixCls + "-mask");
            var safeAreaClass = classNames(prefixCls + "-safe-area");
            var wrapperClass = classNames(prefixCls + "-wrapper");
            return ReactDOM.createPortal(h("div", { className: classes, style: __assign({ zIndex: zIndex }, style), "data-testid": testId },
                h("div", { className: maskClass, ref: _this.maskRef, style: maskStyle }),
                h("div", { className: safeAreaClass, ref: _this.safeAreaRef },
                    h("div", { className: wrapperClass, ref: _this.wrapperRef, onClickCapture: _this.handleClick }, _this.renderPages(classNames)),
                    h(Surroundings, { actionSheetConfig: actionSheetConfig, images: _this.imageList, currentIndex: currentIndex, isActionSheetVisible: isActionSheetVisible, onActionSheetClose: _this.handleActionSheetClose, onClose: _this.requestClose, renderWidgets: renderWidgets, showPageNumber: showPageNumber, isWidgetsVisible: isWidgetsVisible, showCloseButton: showCloseButton }))), containerDom || document.body);
        };
        return _this;
    }
    Preview.getDerivedStateFromProps = function (props, state) {
        if (typeof props.index === 'number') {
            return { currentIndex: props.index };
        }
        return null;
    };
    Preview.prototype.componentDidMount = function () {
        if (this.props.visible) {
            this.handleDomMounted();
        }
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('orientationchange', this.handleResize);
    };
    Preview.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a, _b, _c;
        if (prevProps.visible && !this.props.visible) {
            (_a = this.touchGesture) === null || _a === void 0 ? void 0 : _a.destroy();
            this.touchGesture = null;
        }
        if (prevState.currentIndex !== this.state.currentIndex) {
            (_b = this.touchGesture) === null || _b === void 0 ? void 0 : _b.updateProps({ currentIndex: this.state.currentIndex });
        }
        if (!prevProps.visible && this.props.visible) {
            this.handleDomMounted();
            if (typeof this.props.index !== 'number') {
                var index = this.props.initialIndex;
                (_c = this.touchGesture) === null || _c === void 0 ? void 0 : _c.updateProps({ currentIndex: index });
                this.updateCurrentPage(index);
                return;
            }
        }
        if (this.getImageCount(prevProps) !== this.imageCount) {
            this.updateCurrentPage();
        }
    };
    Preview.prototype.componentWillUnmount = function () {
        var _a;
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('orientationchange', this.handleResize);
        (_a = this.touchGesture) === null || _a === void 0 ? void 0 : _a.destroy();
    };
    Preview.prototype.getUrl = function (index) {
        var _a;
        var _b = this.props, urlList = _b.urlList, images = _b.images;
        return ((_a = images === null || images === void 0 ? void 0 : images[index]) === null || _a === void 0 ? void 0 : _a.url) || (urlList === null || urlList === void 0 ? void 0 : urlList[index]);
    };
    Object.defineProperty(Preview.prototype, "imageCount", {
        get: function () {
            return this.getImageCount(this.props);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preview.prototype, "imageList", {
        get: function () {
            var _a = this.props, urlList = _a.urlList, images = _a.images;
            if (images) {
                return images;
            }
            return (urlList === null || urlList === void 0 ? void 0 : urlList.map(function (url) { return ({ url: url }); })) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preview.prototype, "shouldDisableLongTapBehavior", {
        get: function () {
            var _a = this.props, actionSheetConfig = _a.actionSheetConfig, disableSystemLongTap = _a.disableSystemLongTap;
            return Boolean(actionSheetConfig) || disableSystemLongTap;
        },
        enumerable: false,
        configurable: true
    });
    Preview.prototype.getImageCount = function (props) {
        var urlList = props.urlList, images = props.images;
        return (images || urlList || []).length;
    };
    Preview.prototype.handleDomMounted = function () {
        this.initTouchGesture();
        this.updateCurrentPage();
        this.handleResize();
    };
    Preview.prototype.initTouchGesture = function () {
        if (this.touchGesture) {
            this.touchGesture.destroy();
        }
        var currentIndex = this.state.currentIndex;
        var _a = this.props, scaleOnDoubleTap = _a.scaleOnDoubleTap, allowTapToClose = _a.allowTapToClose, maxScale = _a.maxScale, allowSwipeDownToClose = _a.allowSwipeDownToClose, allowSwipeUpToClose = _a.allowSwipeUpToClose;
        this.touchGesture = new TouchGesture({
            disableSystemLongTap: this.shouldDisableLongTapBehavior,
            wrapperRef: this.wrapperRef,
            safeAreaRef: this.safeAreaRef,
            maskRef: this.maskRef,
            pageRef: this.pageRef,
            imageWrapperRef: this.imageWrapperRef,
            imageRef: this.imageRef,
            onChangePage: this.handlePageChange,
            onWidgetsVisibilityChange: this.handleWidgetsVisibilityChange,
            canPinchZoom: this.canPinchZoom,
            onClose: this.requestClose,
            onTap: this.handleTap,
            onLongTap: this.handleLongTap,
            onLongTapCancel: this.handleLongTapCancel,
            images: this.imageList,
            currentIndex: currentIndex,
            scaleOnDoubleTap: scaleOnDoubleTap,
            maxScale: maxScale,
            allowSwipeDownToClose: allowSwipeDownToClose,
            allowSwipeUpToClose: allowSwipeUpToClose,
            allowTapToClose: allowTapToClose,
        });
    };
    Preview.prototype.updateCurrentPage = function (pageIndex, animated) {
        var _a;
        if (pageIndex === void 0) { pageIndex = this.state.currentIndex; }
        if (animated === void 0) { animated = true; }
        var length = this.imageCount;
        if (!length) {
            this.requestClose();
        }
        var index = Math.max(0, Math.min(pageIndex, length - 1));
        this.setState({
            currentIndex: index
        });
        (_a = this.touchGesture) === null || _a === void 0 ? void 0 : _a.toCurrentPageLeft(animated ? 200 : 0);
    };
    Preview.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Preview.prototype.renderPlaceholder = function (classNames, i) {
        var prefixCls = this.props.prefixCls;
        var _a = this.state, currentIndex = _a.currentIndex, screenWidth = _a.screenWidth;
        var isRight = i > currentIndex;
        var key = isRight ? 'right' : 'left';
        var placeholderClass = classNames(prefixCls + "-placeholder", prefixCls + "-placeholder-" + key);
        var holdPages = isRight ? this.imageCount - i : i + 1;
        return h("div", { key: key, className: placeholderClass, style: { width: holdPages * screenWidth } });
    };
    Preview.prototype.renderSinglePage = function (classNames, i) {
        var _a;
        var _this = this;
        var _b = this.props, prefixCls = _b.prefixCls, disableSystemLongTap = _b.disableSystemLongTap, imageStyle = _b.imageStyle;
        var _c = this.state, currentIndex = _c.currentIndex, imageStates = _c.imageStates, screenWidth = _c.screenWidth;
        var indexDelta = Math.abs(i - currentIndex);
        if (indexDelta > 2) {
            return null;
        }
        if (indexDelta === 2) {
            return this.renderPlaceholder(classNames, i);
        }
        var isCurrent = i === currentIndex;
        var pageClass = classNames(prefixCls + "-page", (_a = {},
            _a[prefixCls + "-page-current"] = isCurrent,
            _a));
        var imageLoadingClass = classNames(prefixCls + "-image-loading");
        var imageErrorClass = classNames(prefixCls + "-image-error");
        var imageContainerClass = classNames(prefixCls + "-image-container");
        var imageWrapperClass = classNames(prefixCls + "-image-wrapper");
        var imageClass = classNames(prefixCls + "-image");
        var imageUrl = this.getUrl(i);
        return (h("div", { className: pageClass, ref: isCurrent ? this.pageRef : null, key: i, style: {
                minWidth: screenWidth + 'px',
                maxWidth: isCurrent ? 'none' : screenWidth + 'px'
            } },
            h("div", { className: imageContainerClass },
                h("div", { className: imageWrapperClass, ref: isCurrent ? this.imageWrapperRef : null, key: imageUrl },
                    h("img", { className: imageClass, style: __assign({ visibility: imageStates[imageUrl] === 'loaded' ? 'visible' : 'hidden', WebkitTouchCallout: ua.isIOS && ua.isQQMiniProgram && !disableSystemLongTap ? 'initial' : 'none', pointerEvents: this.shouldDisableLongTapBehavior ? 'none' : 'auto' }, imageStyle), src: imageUrl, key: imageUrl, ref: i === currentIndex ? this.imageRef : null, onLoad: function () { return _this.setImageState(imageUrl, 'loaded'); }, onError: function () { return _this.setImageState(imageUrl, 'error'); } }),
                    !imageStates[imageUrl] && h(Loading, { className: imageLoadingClass, spinType: "light" }),
                    imageStates[imageUrl] === 'error' && h("div", { className: imageErrorClass }, i18n('loadingFailed'))))));
    };
    Preview.prototype.renderPages = function (classNames) {
        var _this = this;
        return this.imageList
            .map(function (v, i) { return _this.renderSinglePage(classNames, i); })
            .filter(function (page) { return page; });
    };
    return Preview;
}(React.Component));
export default Preview;
Preview.defaultProps = {
    visible: true,
    prefixCls: 'dui-m-preview',
    initialIndex: 0,
    maskStyle: {},
    showPageNumber: true,
    allowSwipeDownToClose: true,
    allowSwipeUpToClose: false,
    allowTapToClose: true,
    maxScale: 10,
    scaleOnDoubleTap: 2,
    onChange: emptyFn,
    onTapImage: emptyFn,
    onClose: emptyFn,
    onLongTapImage: emptyFn,
    actionSheetConfig: ua.isQQ || ua.isWeChat || ua.isWxWork || ua.isTim || ua.isMiniProgram ? null : [],
    containerDom: typeof document !== 'undefined' ? document.body : undefined,
    disableSystemLongTap: false,
    showCloseButton: true,
};
